// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `#acContainer.mobile {
  height: 100vh;
  width: 100vw;
  background-color: white;
  position: fixed;
  top: 0;
  left: 0;
  z-index: 1991 !important;
}

.acInput {
  width: 100% !important;
}

.acInput-mobile-container {
  position: fixed !important;
  top: 0;
  z-index: 1992 !important;
  width: calc(100vw - 24px);
  border: 1px #c8c8c8 solid;
  border-radius: 5px;
  margin: 8px 12px;
}
.acInput-mobile-container .acInput-mobile {
  width: calc(100vw - 40px);
  border: 0;
  padding: 8px 10px 0px 10px;
  margin: 0 0 6px 6px;
  font-size: 20px;
  background-color: white;
}
.acInput-mobile-container .acInput-mobile:focus {
  outline: 0 !important;
}
.acInput-mobile-container button {
  margin-top: 2px;
  padding: 0 !important;
  height: 40px;
  font-size: 1.5rem;
  color: #6e6e6e;
  width: 40px !important;
  min-width: 40px !important;
}
.acInput-mobile-container button i {
  color: #6e6e6e;
  top: 6px;
}

.acOptions {
  margin-top: 60px;
  margin-bottom: 60px;
  height: calc(100vh - 120px);
  overflow-y: auto;
}
.acOptions .acOption {
  color: #424242;
  border-bottom: 1px #e8e8e8 solid;
  padding: 14px;
}
.acOptions .acOption:hover {
  background-color: rgb(241, 241, 241);
}

.mobile-buttons {
  background-color: #023b48 !important;
  color: white !important;
  position: fixed;
  height: 50px;
  bottom: 0px;
  font-size: 14px;
  left: 0px;
  width: 100%;
  text-align: center;
  display: inline-block;
  vertical-align: middle;
  box-shadow: 0px -1px 4px 0px rgb(120, 120, 120);
  z-index: 1993 !important;
}
.mobile-buttons button {
  display: inline-block;
  margin-top: 4px;
  vertical-align: middle;
}

.matForm {
  width: 100%;
}

.matFormMobile {
  width: 100%;
}
.matFormMobile input {
  font-size: 20px;
}`, "",{"version":3,"sources":["webpack://./src/app/directivas/components/ax-autocomplete/ax-autocomplete.component.scss","webpack://./src/assets/css/colores.scss"],"names":[],"mappings":"AAGE;EACE,aAAA;EACA,YAAA;EACA,uBAAA;EACA,eAAA;EACA,MAAA;EACA,OAAA;EACA,wBAAA;AAFJ;;AAMA;EACE,sBAAA;AAHF;;AAcA;EACE,0BAAA;EACA,MAAA;EACA,wBAAA;EACA,yBAAA;EACA,yBAAA;EACA,kBAAA;EACA,gBAAA;AAXF;AAYE;EACE,yBAAA;EACA,SAAA;EACA,0BAAA;EACA,mBAAA;EACA,eAAA;EACA,uBAAA;AAVJ;AAWI;EACE,qBAAA;AATN;AAYE;EACE,eAAA;EACA,qBAAA;EACA,YAAA;EACA,iBAAA;EACA,cC5BO;ED6BP,sBAAA;EACA,0BAAA;AAVJ;AAWI;EACE,cChCK;EDiCL,QAAA;AATN;;AAcA;EACE,gBAAA;EACA,mBAAA;EACA,2BAAA;EACA,gBAAA;AAXF;AAYE;EACE,cC1Cc;ED2Cd,gCAAA;EACA,aAAA;AAVJ;AAWI;EACE,oCAAA;AATN;;AAcA;EACE,oCAAA;EACA,uBAAA;EACA,eAAA;EACA,YAAA;EACA,WAAA;EACA,eAAA;EACA,SAAA;EACA,WAAA;EACA,kBAAA;EACA,qBAAA;EACA,sBAAA;EAGA,+CAAA;EACA,wBAAA;AAXF;AAYE;EACE,qBAAA;EACA,eAAA;EACA,sBAAA;AAVJ;;AAcA;EACE,WAAA;AAXF;;AAaA;EACE,WAAA;AAVF;AAWE;EACE,eAAA;AATJ","sourcesContent":["@import \"../../../../assets/css/colores.scss\";\n\n#acContainer {\n  &.mobile {\n    height: 100vh;\n    width: 100vw;\n    background-color: white;\n    position: fixed;\n    top: 0;\n    left: 0;\n    z-index: 1991 !important;\n  }\n}\n\n.acInput{\n  width: 100% !important;\n}\n// mat-form-field {\n//   .mat-form-field-infix{\n//     padding: .5em 0 .5em 0 !important;\n//   }\n// }\n// .mat-form-field-appearance-outline .mat-form-field-infix{\n//\n// }\n\n.acInput-mobile-container {\n  position: fixed !important;\n  top: 0;\n  z-index: 1992 !important;\n  width: calc(100vw - 24px);\n  border: 1px #c8c8c8 solid;\n  border-radius: 5px;\n  margin: 8px 12px;\n  .acInput-mobile {\n    width: calc(100vw - 40px);\n    border: 0;\n    padding: 8px 10px 0px 10px;\n    margin: 0 0 6px 6px;\n    font-size: 20px;\n    background-color: white;\n    &:focus {\n      outline: 0 !important;\n    }\n  }\n  button {\n    margin-top: 2px;\n    padding: 0 !important;\n    height: 40px;\n    font-size: 1.5rem;\n    color: $oa-gris;\n    width: 40px !important;\n    min-width: 40px !important;\n    i {\n      color: $oa-gris;\n      top: 6px;\n    }\n  }\n}\n\n.acOptions {\n  margin-top: 60px;\n  margin-bottom: 60px;\n  height: calc(100vh - 120px);\n  overflow-y: auto;\n  .acOption {\n    color: $oa-gris-oscuro;\n    border-bottom: 1px #e8e8e8 solid;\n    padding: 14px;\n    &:hover {\n      background-color: rgb(241, 241, 241);\n    }\n  }\n}\n\n.mobile-buttons {\n  background-color: $oa-background !important;\n  color: white !important;\n  position: fixed;\n  height: 50px;\n  bottom: 0px;\n  font-size: 14px;\n  left: 0px;\n  width: 100%;\n  text-align: center;\n  display: inline-block;\n  vertical-align: middle;\n  -webkit-box-shadow: 0px -1px 4px 0px rgba(120, 120, 120, 1);\n  -moz-box-shadow: 0px -1px 4px 0px rgba(120, 120, 120, 1);\n  box-shadow: 0px -1px 4px 0px rgba(120, 120, 120, 1);\n  z-index: 1993 !important;\n  button {\n    display: inline-block;\n    margin-top: 4px;\n    vertical-align: middle;\n  }\n}\n\n.matForm{\n  width:100%\n}\n.matFormMobile{\n  width:100%;\n  input {\n    font-size: 20px;\n  }\n}\n","\n$oa-principal : #d20a31;\n$oa-principal2 : #6d0015;\n$oa-principal3 : #f06f88;\n\n$oa-secundario : #0a738c;\n$oa-secundario2 : #023b48;\n$oa-secundario3 : #539cad;\n\n$oa-accent : #46c309;\n$oa-accent2 : #216500;\n$oa-accent3 : #90e268;\n\n$oa-accent-secundario : #E1750B;\n$oa-accent-secundario2 : #753A00;\n$oa-accent-secundario3 : #FFBA76;\n\n$oa-background : #023b48;\n\n$oa-blanco-bg : white;\n$oa-blanco : white;\n\n$oa-gris : #6e6e6e;\n$oa-gris-claro : #a3a3a3;\n$oa-gris-oscuro : #424242;\n\n$oa-color-link: #3e92ff;\n\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
